import { useMemo } from 'react';
import {
  OrganizationMembershipResponse,
  OrganizationRoleType,
} from '@/shared/api';

const DEFAULT_ROLES: OrganizationRoleType[] = ['admin', 'member'];
const DEFAULT_ROLE_ROUTES: Record<OrganizationRoleType, string> = {
  admin: '/dashboard',
  member: '/dashboard',
  reader: '/dashboard/reader',
};

export const useRolesAccessVerification = (
  allowedRoles: OrganizationRoleType[] = DEFAULT_ROLES,
  activeOrganization?: Partial<OrganizationMembershipResponse>,
) =>
  useMemo(() => {
    const role = activeOrganization?.role;
    const hasRoleAccess = !!role && allowedRoles.includes(role);

    const roleErrorRedirectPath = activeOrganization?.role
      ? DEFAULT_ROLE_ROUTES[activeOrganization.role]
      : '/';

    return { hasRoleAccess, roleErrorRedirectPath };
  }, [activeOrganization?.role, allowedRoles]);
